import type {NavigationGuard, RouteRecordRaw} from 'vue-router';
import { storeToRefs } from 'pinia';
import {useUserStore} from "@/app/stores/user-store.ts";

export const adminGuard: NavigationGuard = () => {
    const userStore = useUserStore();
    const { isAdmin } = storeToRefs(userStore);

    if (!isAdmin.value) {
        return { path: '/' };
    }
    return true;
};

export const AdminHome: RouteRecordRaw = {
    path: '/admin',
    name: 'adminHome',
    component: () => import('./index.vue'),
    beforeEnter: adminGuard,
};

export const AdminServiceDetail: RouteRecordRaw = {
    path: '/admin/service/detail/:name',
    name: 'adminServiceDetail',
    component: () => import('./service-detail/service-detail.vue'),
    beforeEnter: adminGuard,
};

export const AdminInvoices: RouteRecordRaw = {
    path: '/admin/invoices',
    name: 'adminInvoices',
    component: () => import('./invoices/invoices.vue'),
    beforeEnter: adminGuard,
};

export const AdminActors: RouteRecordRaw = {
    path: '/admin/actor/:id',
    name: 'adminActors',
    component: () => import('./actors/actors.vue'),
    beforeEnter: adminGuard,
};

export const AdminSessions: RouteRecordRaw = {
    path: '/admin/sessions',
    name: 'adminSessions',
    component: () => import('./sessions/sessions.vue'),
    beforeEnter: adminGuard,
};

export const AdminSessionDetail: RouteRecordRaw = {
    path: '/admin/sessions/:type/:id',
    name: 'adminSessionDetail',
    component: () => import('./sessions/session-detail.vue'),
    beforeEnter: adminGuard,
};

export const AdminProcessDetail: RouteRecordRaw = {
    path: '/admin/process/:type',
    name: 'adminProcessDetail',
    component: () => import('./process-detail/process-detail.vue'),
    beforeEnter: adminGuard,
};


export const AdminSettings: RouteRecordRaw = {
    path: '/admin/settings',
    name: 'adminSettings',
    component: () => import('./settings/settings.vue'),
    beforeEnter: adminGuard,
};

export const AdminActorSearch: RouteRecordRaw = {
    path: '/admin/actors',
    name: 'adminActorSearch',
    component: () => import('./actor-search/actor-search.vue'),
    beforeEnter: adminGuard,
};

export default [
    AdminHome,
    AdminServiceDetail,
    AdminInvoices,
    AdminActors,
    AdminActorSearch,
    AdminSessions,
    AdminSessionDetail,
    AdminProcessDetail,
    AdminSettings
]
